<template>
  <div id="modalDetalhamentoCompra">
    <q-dialog v-model="OpenDialogDetalhamentoCompra" @hide="closeModal()">
      <q-card style="width: 800px; max-width: 100%; max-height: 90vh; display: flex; flex-direction: column;">
        <q-card-section class="row items-center no-wrap">
          <div class="text-h6">
            Detalhamento {{ $formatDate(titulo.data) }} {{ titulo.descricao }}
            <span v-if="!loading">R$ {{ $currency(titulo.valor) }}</span>
          </div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-separator />

        <q-card-section v-if="loading" class="text-center">
          <q-spinner color="blue-7" size="3em" />
        </q-card-section>

        <q-card-section v-else style="overflow-y: auto;">
          <div class="row q-col-gutter-sm q-mb-md">
            <div class="col-6 col-sm-3">
              <div class="text-caption text-grey-7">Compra</div>
              <div>{{ compra.id }}</div>
            </div>
            <div class="col-6 col-sm-3">
              <div class="text-caption text-grey-7">Data da compra</div>
              <div>{{ $formatDate(compra.dtmovimento) }}</div>
            </div>
            <div class="col-6 col-sm-3">
              <div class="text-caption text-grey-7">Status</div>
              <div>{{ compra.status }}</div>
            </div>
            <div class="col-6 col-sm-3">
              <div class="text-caption text-grey-7">Total da compra</div>
              <div>R$ {{ $currency(compra.total) }}</div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="text-caption text-grey-7">Fornecedor</div>
              <div>{{ compra.fornecedor || "Não informado" }}</div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="text-caption text-grey-7">Comprado por</div>
              <div>
                {{ compra.usuario || "Não informado" }}
                <span v-if="compra.movcaixa_id" class="text-grey-7">(no caixa {{ compra.movcaixa_id }})</span>
              </div>
            </div>
            <div v-if="compra.observacao" class="col-12">
              <div class="text-caption text-grey-7">Observação</div>
              <div>{{ compra.observacao }}</div>
            </div>
          </div>

          <q-table
            class="q-pa-none"
            flat
            dense
            :rows="itens"
            :columns="columns"
            row-key="id"
            :pagination="{ rowsPerPage: 0 }"
            hide-bottom
            no-data-label="Nenhum item encontrado"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="produto" :props="props">
                  {{ props.row.produto }}
                  <span v-if="props.row.concurso" class="text-grey-7">- Concurso {{ props.row.concurso }}</span>
                </q-td>
                <q-td key="quantidade" :props="props">{{ props.row.quantidade }}</q-td>
                <q-td key="vlrvenda" :props="props">R$ {{ $currency(props.row.vlrvenda) }}</q-td>
                <q-td key="valor" :props="props">R$ {{ $currency(props.row.valor) }}</q-td>
              </q-tr>
            </template>
            <template v-slot:bottom-row>
              <q-tr class="text-weight-bold">
                <q-td>Total</q-td>
                <q-td class="text-right">{{ total.quantidade }}</q-td>
                <q-td />
                <q-td class="text-right">R$ {{ $currency(total.valor) }}</q-td>
              </q-tr>
            </template>
          </q-table>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { bus } from "@/utils/bus";

export default {
  name: "modal-detalhamento-compra",
  data() {
    return {
      OpenDialogDetalhamentoCompra: false,
      loading: false,
      titulo: {},
      compra: {},
      itens: [],
      total: { quantidade: 0, valor: 0 },
      columns: [
        { name: "produto", label: "Produto", field: "produto", align: "left" },
        { name: "quantidade", label: "Quantidade", field: "quantidade", align: "right" },
        { name: "vlrvenda", label: "Preço de venda", field: "vlrvenda", align: "right" },
        { name: "valor", label: "Valor lançado", field: "valor", align: "right" }
      ]
    };
  },
  methods: {
    open(movconta) {
      this.titulo = { data: movconta.dtmovimento, descricao: movconta.descricao, valor: 0 };
      this.compra = {};
      this.itens = [];
      this.loading = true;
      this.OpenDialogDetalhamentoCompra = true;

      axios
        .get(`/financeiro/detalhamento-compra/${movconta.id}`)
        .then(res => {
          if (!res.data.success) {
            this.OpenDialogDetalhamentoCompra = false;
            this.$q.notify({ message: res.data.message, color: "orange", position: "top-right" });
            return;
          }

          this.titulo = res.data.data.titulo;
          this.compra = res.data.data.compra;
          this.itens = res.data.data.itens;
          this.total = res.data.data.total;
        })
        .catch(() => {
          this.OpenDialogDetalhamentoCompra = false;
          this.$q.notify({
            message: "Houve um erro ao visualizar o detalhamento da compra",
            color: "red",
            position: "top-right"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeModal() {
      this.OpenDialogDetalhamentoCompra = false;
    }
  },
  mounted() {
    bus.on("abrirModalDetalhamentoCompra", movconta => {
      this.open(movconta);
    });
  },
  beforeUnmount() {
    bus.off("abrirModalDetalhamentoCompra");
  }
};
</script>
